export default {
  lang: {
    choose: '语言/Language',
    zhcn: '简体中文',
    zhtw: '繁體中文(臺灣)',
    en: 'English',
    es: 'Español',
    ru: 'Русский',
    de: 'Deutsch',
    sv: 'Svenska',
    ja: '日本語',
    changeok: 'Switch Language Success'
  },
  btn: {
    ok: 'OK',
    cancel: 'Cancel',
    cont: 'Continue'
  },
  menu: {
    upload: 'Upload',
    newfolder: 'New Folder',
    del: 'Delete',
    up: 'Parent Folder',
    refresh: 'Refresh',
    dfu: 'DFU',
  },
  status: {
    connected: 'Connected, Version: ',
    version: 'Version:',
    mac: 'MAC Address:',
    loading: 'loading…',
  },
  conn: {
    connect: 'Connect',
    connecting: 'Connecting…',
    disconnect: 'Disconnect…',
    consuccess: 'Successfully connected to Pixl.js!',
    disconnected: 'Pixl.js has been disconnected!',
    connfailed: 'Pixl.js connection failed!'
  },
  labels: {
    name: 'Name',
    size: 'Size',
    type: 'Type',
    remark: 'Remark'
  },
  contxmenu: {
    del: 'Delete…',
    rename: 'Rename…',
    prop: 'Properties…',
    format: 'Format…'
  },
  properties: {
    title: 'Properties',
    remark: 'Remark',
    entermsg: 'Please enter remarks',
    attrib: 'Attributes',
    hide: 'Hide',
    readonly: "Read only",
    errupdate: 'Failed to update properties!',
    remarktoolong: 'Remarks can only be up to 90 bytes!, that is, 90 characters or 30 Chinese characters (current: ',
    remarktoolongend: ' Bytes）'
  },
  upload: {
    title: 'Upload',
    drag: 'Drag files here, or ',
    click: 'click to upload.',
    maxsize: 'The total length of the file path cannot exceed 63 bytes.',
    maxname: 'The file name cannot exceed 47 bytes.',
    closetitle: 'Confirm to close?',
    closemessage: 'Closing dialog will clear the upload record.  And will abort the upload queue.',
    errupload: 'Upload failed: '
  },
  format: {
    title: 'Formatear',
    messrow1a: 'Do you want to format ',
    messrow1b: ' ?',
    messrow2: 'Formatting will delete all data!',
    messrow3: 'Formatting may take about 10 seconds, please be patient.',
    formatok: 'Format completed!',
    formaterr: 'Format failed!: '
  },
  del: {
    title: 'Delete',
    message: 'Delete file: ',
    messageend: ' ?',
    error: 'Failed to delete file!: ',
    deleteok: 'File deleted successfully!'
  },
  dfumode: {
    title: 'DFU Mode',
    startconfirm: 'Enter DFU mode?',
    updateconfirm: 'Entering DFU mode successfully. Do you want to open the DFU upgrade page?',
    updatetitle: 'DFU Mode accepted'
  },
  oldfirm: {
    title: 'Upgrade tips',
    message: 'The firmware version of your device is too low. Please update the latest version of the firmware before using the upload function.'
  },
  newfolder: {
    title: 'New Folder',
    message: 'Please enter the folder name',
    newfoldererr: 'Failed to create folder!:'
  },
  rename: {
    title: 'Rename',
    message: 'Please enter a new file name: ',
    errrename: 'Rename failed!: ',
    nametoolong: 'The maximum file path length cannot exceed 63 bytes',
    pathtoolong: 'The maximum file name cannot exceed 47 bytes'
  },
  drive: {
    message: '(Disk not available [error code: ',
    messageend: '])'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en_US.js